import React from 'react';
import { Link } from 'react-router-dom';
import { useQuery } from '@tanstack/react-query';

import { Loader } from '@components';
import { sitesQuery } from '@queries';

const Site = ({ site }) => {
  return (
    <div className="sb-sidebar-search-item">
      <div>
        <Link to={`/dashboard/sites/${site.id}`} title={site.display_url}>
          {site.display_url}
        </Link>
      </div>
    </div>
  );
};

export const SearchSites = ({ searchTerm }) => {
  // Fetch sites
  const {
    data: sitesData,
    isPending: sitesIsPending,
    isError,
  } = useQuery(
    sitesQuery({
      q: searchTerm,
      deleted: 0,
      limit: 3,
      order_by: 'base_directory',
      type: 'default',
    }),
  );

  return (
    <>
      {sitesIsPending && (
        <Loader className="sb-loader sb-loader-sidebar-search" />
      )}
      {!sitesIsPending && sitesData.objects.length > 0 && (
        <>
          <h2>Websites</h2>
          <div className="sb-sidebar-search-row">
            {sitesData.objects.map((site) => {
              return <Site key={site.id} site={site} />;
            })}
          </div>
        </>
      )}
    </>
  );
};
